import { Box, ListItem } from "arkh";
import React from "react";
import { Task } from "../State/Routine/types";
import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";
import { TaskTypeIcon, TaskTypeIconSize } from "@/src/types/TaskTypeIcon";

export function BasicTaskItem(props: { task: Task }) {
  const hasPlaceholder = props.task.title === "";
  const intl_tokens = useIntlTokens();
  return (
    <Box style={{ flex: 1, flexDirection: "row", alignItems: "center" }}>
      <Box spaceRight="small">
        <TaskTypeIcon
          size={TaskTypeIconSize.XSMALL}
          type={
            props.task.type === "TaskCheck"
              ? {
                  __typename: "TaskCheck",
                  sentiments: props.task.sentiments,
                }
              : props.task.type === "TaskNumber"
                ? { __typename: "TaskNumber", unit: props.task.unit }
                : { __typename: "TaskText" }
          }
        />
      </Box>
      <ListItem.Title color={hasPlaceholder ? "text-washed" : undefined}>
        {props.task.title || intl_tokens.Title}
      </ListItem.Title>
    </Box>
  );
}
